<div class="right-sidebar-container" #sidebarContainer>
    <div class="right-sidebar-container" #sidebarContent>
        <!-- Sticky Search Bar -->
        <div class="sticky-search">
            <app-search-bar></app-search-bar>
        </div>

        <!-- Who to Follow Widget -->
        <div *ngIf="showWhoToFollow">
            <app-who-to-follow [UserID]="UserID"
                               (hasData)="toggleWidgetVisibility('whoToFollow', $event)">
            </app-who-to-follow>
        </div>

        <!-- Trending Topics Widget -->
        <div *ngIf="showTrendingTopics" class="widget-container">
            <app-trending-topics [UserID]="UserID"
                                 (hasData)="toggleWidgetVisibility('trendingTopics', $event)">
            </app-trending-topics>
        </div>

        <!-- Sponsored Posts Widget -->
        <div *ngIf="showSponsoredPosts" class="widget-container">
            <app-sponsored-posts [UserID]="UserID"
                                 (hasData)="toggleWidgetVisibility('sponsoredPosts', $event)">
            </app-sponsored-posts>
        </div>
    </div>
</div>
